<template>
    <div class="department"
         v-loading="loading"
         element-loading-text="拼命加载中">
        <div class="department-box">
            <ul class="aside">
                <li class="title">
                    <h3>
                        分类类别
                    </h3>
                </li>
                <li class="down">
                    <el-tree :data="experList" :props="{children: 'children',label: 'name'}"
                             @node-click="selectNode"></el-tree>
                </li>
            </ul>
            <el-card class="box-card main" style="padding-top: 10px;">
                <el-header style="text-align: right; font-size: 12px">
                    <el-button type="text" @click="addHandle">新增子类</el-button>
                    <el-button  v-if="selectData.typeCode" type="text" @click="editHandle">修改</el-button>
                </el-header>
                <el-form label-position="right" label-width="120px" :model="selectData">
                    <el-form-item label="分类代码">
                        <el-input v-model="selectData.typeCode" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="分类名称">
                        <el-input v-model="selectData.typeName" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input v-model="selectData.remark" readonly></el-input>
                    </el-form-item>
                </el-form>
            </el-card>
        </div>
        <el-dialog
            :title="dialogTitle"
            :close-on-click-modal="false"
            :visible.sync="visible">
            <el-form :model="dataForm" :rules="rules" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                     label-width="160px">
                <el-form-item label="分类代码" prop="typeCode">
                    <el-input v-model="dataForm.typeCode" placeholder="分类代码"></el-input>
                </el-form-item>
                <el-form-item label="分类名称" prop="typeName">
                    <el-input v-model="dataForm.typeName" placeholder="分类名称"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
                </el-form-item>
                <el-form-item label="所属分类" prop="typeParentId">
                    <el-select filterable  v-model="dataForm.typeParentId" placeholder="请选择">
                        <el-option value="0" label="青选择"></el-option>
                        <el-option
                            v-for="item in selectList"
                            :key="item.id"
                            :label="item.typeName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible = false">取消</el-button>
                <el-button type="primary" :loading="btnLoading" @click="dataFormSubmit()">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {cloneDeep} from 'lodash'

export default {
    name: "professional",
    data() {
        return {
            visible: false,
            flag: true,
            loading: true,
            dialogTitle: '新增',
            selectList: [],
            experList: [],
            selectData: {},
            dataForm: {
                typeId: '',
                typeParentId: '',
                typeCode: '',
                typeName: '',
                remark: ''
            },
            rules: {
                typeCode: [
                    {required: true, message: '请填写分类代码', trigger: 'blur'}
                ],
                typeName: [
                    {required: true, message: '请填写分类名称', trigger: 'blur'}
                ]
            },
            btnLoading: false
        }
    },
    methods: {
        // 获取所有节点
        getExperTree() {
            this.loading = true;
            this.$http.get('/basic/baseClassifyType/allTree').then(res => {
                const {data} = res;
                this.experList = data.data
                this.loading = false
            }).catch(err => {
                console.log(err)
            })
        },
        // 选择每一项
        selectNode(data) {
            this.flag = true;
            if (undefined != data.id && '' != data.id) {
                this.selectData = data;
                this.getDetail()
            }
        },
        // 获取详情
        getDetail() {
            this.$http.get(`/basic/baseClassifyType/${this.selectData.id}`).then(res => {
                this.loading = false
                this.flag = false
                this.selectData = res.data.data;
            }).catch(err => {
                console.log(err)
            })
        },
        // 添加
        addHandle() {
            this.dialogTitle = '新增'
            const  {typeParentId} = JSON.parse(JSON.stringify(this.selectData));
            this.dataForm = {
                typeParentId,
            };
            this.visible = true;
        },
        // 修改
        editHandle() {
            this.dialogTitle = '修改'
            this.visible = true;
            this.$nextTick(()=>{
                const {id, typeCode, name, remark, parentId} = JSON.parse(JSON.stringify(this.selectData));
                this.dataForm.typeCode = typeCode;
                this.dataForm.typeName = name;
                this.dataForm.remark = remark;
                this.dataForm.typeId = id;
                this.dataForm.typeParentId = parentId;
                this.dataForm.id = id;
            })
        },
        // 获取所有节点
        getSelectList() {
            this.$http.get('/basic/baseClassifyType/allNode').then(res => {
                this.selectList = res.data.data;
            }).catch(err => {
                console.log(err)
            })
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs.dataForm.validate((valid) => {
                if (valid) {
                    this.submitData()
                } else {
                    return false;
                }
            });
        },
        submitData() {
            this.btnLoading = true;
            this.$http.post('/basic/baseClassifyType/saveBaseClassifyType', {...this.dataForm}).then(({data}) => {
                if (data && data.code === '1') {
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 1500,
                        onClose: () => {
                            this.visible = false
                            this.$emit('refreshDataList')
                            this.reloadData()
                            if (this.dataForm.id) {
                                this.getDetail()
                            }
                        }
                    })
                } else {
                    this.$message.error(data.msg)
                }
            }).finally(() => {
                this.btnLoading = false;
            })
        },
        // 加载数据
        reloadData() {
            this.getSelectList();
            this.getExperTree();
        }
    },
    created() {
        this.reloadData()
    }
}
</script>

<style lang="scss" scoped>
.department {
    position: absolute;
    height: 100%;
    top: 0;
    width: 100%;

    .department-box {
        display: flex;
        height: 100%;
    }
}

.site-content {
    position: fixed;
    top: 25%;
    left: 50%;
    z-index: 2;
    padding: 30px;

    text-align: center;
    transform: translate(-50%, 0);
}

.not-found-title {
    margin: 20px 0 15px;
    font-size: 10em;
    font-weight: 400;
    color: rgb(55, 71, 79);
}

.text-button-larger {
    font-size: 26px;
    line-height: 26px;
    margin-top: 40px;
}

.department-box {
    .aside, .main {
        background-color: #fff;
        height: 98%;
    }

}

.text-button {
    margin-right: 10px;
}
</style>
